module.exports = __webpack_public_path__ + "img/feature_payment_old.af2b8954.png";